import React from 'react';
import './SmallAlert.scss';
import { Grid } from '@material-ui/core';
import { WarningFilled } from '@one-thd/sui-icons';
export var SmallAlert = function (_a) {
    var alertMessage = _a.alertMessage, _b = _a.isMultiLine, isMultiLine = _b === void 0 ? true : _b;
    return (React.createElement(Grid, { item: true, container: true, xs: 12, className: "SmallAlert__WarningDialogBoxBorder".concat(isMultiLine ? 'Multi' : '', " sui-flex sui-flex-row sui-justify-start sui-align-start") },
        React.createElement(Grid, { item: true, xs: 2, className: "SmallAlert__WarningDialogBox sui-flex sui-flex-col sui-justify-start sui-align-center sui-pl-2" },
            React.createElement(WarningFilled, { color: "current", size: "small" })),
        React.createElement(Grid, { item: true, xs: 10, className: "sui-flex sui-flex-col sui-justify-start sui-align-center sui-py-2" },
            React.createElement("div", { className: "SmallAlert__AlertText".concat(isMultiLine ? 'Multi sui-px-2' : '') }, alertMessage))));
};
